import 'whatwg-fetch'
import firebase from 'firebase'
import { push } from 'react-router-redux'

import { START_PARSING } from 'modules/sites/action-types'
import { PAUSE_WARM, RESUME_WARM, STOP_WARM } from 'modules/queues/action-types'
import { SITEMAP_PARSE_API, SITEMAP_RESTART_API, LINKS_LIST_PATH, CRAWLER_API } from 'config'
import { getCurrentSiteId, getSiteByKey } from 'modules/sites/selectors'
import { getFirstAccount } from 'modules/accounts'
import { getAuthToken } from 'modules/auth'
import { firebaseDb } from 'modules/firebase'

const requestParsing = (getState, dispatch, payload) => {
  const state = getState()
  firebaseDb.ref(`/queues/${payload.siteId}/${payload.queueId}`)
    .push({
      'status': 'STARTED',
      'timestamp': firebase.database.ServerValue.TIMESTAMP,
      'message': 'STARTED'
    })
    .then(() => {
      const params = [getFirstAccount(state).key, payload.siteId, payload.queueId]
      const site = getSiteByKey(state, payload.siteId);
      const url = site.mode === 'crawler' ? CRAWLER_API : SITEMAP_PARSE_API;
      getAuthToken().then(function(idToken) {
        fetch(`${url}/${params.join('/')}`, {
          method: 'GET',
          headers: new Headers({
            'Authorization': 'Bearer ' + idToken,
            'Content-Type': 'application/json'
          })
        })
        dispatch(push(`${LINKS_LIST_PATH.replace(':site', payload.siteId).replace(':queue', payload.queueId)}`))
      })
    })
}

const pauseWarm = (getState, queue) => {
  const state = getState()
  const siteId = getCurrentSiteId(state)
  firebaseDb.ref(`/queues/${siteId}/${queue}`).push({
    'status': 'PAUSED',
    'timestamp': firebase.database.ServerValue.TIMESTAMP,
  })
}

const resumeWarm = (getState, queue) => {
  const state = getState()
  const siteId = getCurrentSiteId(state)
  firebaseDb.ref(`/queues/${siteId}/${queue}`)
    .push({
      'status': 'WARMING',
      'timestamp': firebase.database.ServerValue.TIMESTAMP,
    })
    .then(() => {
      const params = [getFirstAccount(state).key, siteId, queue]
      getAuthToken().then(function(idToken) {
        fetch(`${SITEMAP_RESTART_API}/${params.join('/')}`, {
          method: 'GET',
          headers: new Headers({
            'Authorization': 'Bearer ' + idToken,
            'Content-Type': 'application/json'
          })
        })
      })
    })
}

const stopWarm = (getState, queue) => {
  const state = getState()
  const siteId = getCurrentSiteId(state)
  firebaseDb.ref(`/queues/${siteId}/${queue}`).push({
    'status': 'STOPPED',
    'timestamp': firebase.database.ServerValue.TIMESTAMP,
  })
}


export default ({ getState, dispatch }) => next => action => {
  if (typeof action !== 'object') {
    return next(action)
  }

  switch (action.type) {
    case START_PARSING:
      requestParsing(getState, dispatch, action.payload);
      break;

    case PAUSE_WARM:
      pauseWarm(getState, action.payload);
      break;

    case RESUME_WARM:
      resumeWarm(getState, action.payload);
      break;

    case STOP_WARM:
      stopWarm(getState, action.payload);
      break;

    default:
      break;
  }

  return next(action)
}



// WEBPACK FOOTER //
// ./src/redux/middlewares/sitemapProcessing.js